import { bindActionCreators } from 'redux';

import { checkStatusAndSwitchToComponentThunk as checkStatusAndSwitchToComponent } from 'app/ComponentSearch/thunks';
import { clearComponentUsage } from 'app/ComponentUsage/actions';
import { getComponentUsage } from 'app/ComponentUsage/thunks';
import { parametersSelector } from 'app/Experiments/selectors';
import { notifySuccess } from 'app/Notifications/actions';
import { isPageSelectedSelector } from 'app/Page/selectors';
import { visitComponent, visitPage } from 'app/Router/actions';
import lanIdSelector from 'app/UserInfo/selectors/lanId';
import connect from 'utils/store/connect';

import ChildrenComponentsList from './components/ChildrenComponentsList';

/**
 * map redux state to props
 * @param {object} state - redux state
 * @returns {object} component props
 */
export const mapState = state => ({
  isPageSelected: isPageSelectedSelector(state),
  experimentParameters: parametersSelector(state),
  lanId: lanIdSelector(state)
});

/**
 * map action creators to react component properties
 * @param {Function} dispatch - redux dispatch function
 * @returns {object} react props
 */
const mapDispatch = function mapDispatchToProps(dispatch) {
  const bindables = {
    checkStatusAndSwitchToComponent,
    clearComponentUsage,
    getComponentUsage,
    notifySuccess
  };
  return {
    ...bindActionCreators(bindables, dispatch),
    unboundVisitComponent: visitComponent,
    unboundVisitPage: visitPage
  };
};

export default connect(mapState, mapDispatch)(ChildrenComponentsList);
